/*
 * Copyright (c) 2025, Ramble Ventures
 */

export const ButtonsPanel = function (props) {
    return (
        <div>
            {props.children}
        </div>
    )
}
